// Simple content for demo
module.exports = {
  content: 'About the European Commission',
};
